var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('os-button',{staticClass:"rounded-circle pa-0",attrs:{"large":"","icon":"","to":_vm.to,"exact-path":""},on:{"click":(e) => _vm.$emit('click', e)}},[_c('v-icon',[_vm._v("mdi-close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }